var map = {
	"./1 Thumbnail, title_ Kepala BNN RI Tutup Gelaran Smash On Drugs 21st Anniversary Championship.jpg": 26197,
	"./10 Thumbnail, title_ Deputi Pencegahan BNN RI, Beri Penguatan Kepada Mahasiswa UMGO.jpeg": 83095,
	"./2 Thumbnail, title_ BNN Nyatakan Perang Lawan Narkoba di Pesawat Lion Group.jpeg": 6695,
	"./3 Thumbnail, title_ Perkuat Sosialisasi Penyalahgunaan Narkotika, BNI Kerja Sama dengan BNN RI.jpeg": 15542,
	"./4 Thumbnail, title_ MoU KPI dan BNN RI_ Mendorong Kampanye Pemberantasan Narkotika melalui Penyiaran.jpg": 86160,
	"./5 Thumbnail, title_ BNN Jabar gelar Talk show bersama Santri  di Cianjur untuk Pesantren bebas Narkoba.jpg": 26565,
	"./6 Thumbnail, title_ BNN-KASN Siapkan Pengawasan Narkoba di Kalangan ASN.jpg": 68175,
	"./7 Thumbnail, title_ BNN Run 2023, Cegah Penyalahgunaan Narkoba dengan Kegiatan Positif.jpg": 21023,
	"./8 Thumbnail, title_ Kampanye Lawan Narkoba, BNN Gandeng UNPAR Gelar Kompetisi Paduan Suara.jpeg": 11796,
	"./9 Thumbnail, title_ BNN RI utamakan pencegahan dan penghapusan stigma pengguna narkotika.jpg": 86646
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80831;